package io.horion.cv.components.shared

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaFilePdf
import com.varabyte.kobweb.silk.components.icons.fa.FaPen
import com.varabyte.kobweb.silk.components.icons.fa.FaTrash
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.CreateCardSpantextStylecss
import io.horion.cv.styles.CreateCardStylecss
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.CSSLengthOrPercentageValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

@Composable
fun DocumentCard(
    title: String,
    modifiedAgo: String,
    previewSrc: String?,
    onEdit: () -> Unit = {},
    onDelete: () -> Unit = {},
    onDownload: () -> Unit = {},
    onOptionsClick: () -> Unit = {}
) {
    var showMenu by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.gap(8.px)
    ) {
        Box(
            modifier = CreateCardStylecss.toModifier()
//                .width(cardW).height(cardH)
                .backgroundColor(Colors.White)
                .borderRadius(8.px)
                .border(1.px, LineStyle.Solid, Colors.lineBorder)
                .overflow(Overflow.Hidden)
                .position(Position.Relative),
            contentAlignment = Alignment.BottomEnd
        ) {
            if (!previewSrc.isNullOrBlank()) {
                Image(
                    src = previewSrc,
                    description = title,
                    modifier = Modifier
                        .fillMaxWidth()
                        .styleModifier {
                            property("object-fit", "cover")
                            property("object-position", "top")
                        }
                )
            } else {
                Box(
                    modifier = Modifier.fillMaxSize().backgroundColor(Colors.PriceGray),
                    contentAlignment = Alignment.Center
                ) {
                  /*  Image(
                        src = "/pdf-icon.svg",
                        description = "PDF",
                        modifier = Modifier.size(48.px)
                    )*/
                    FaFilePdf(
                        modifier = Modifier.fontSize(48.px)
                    )
                }
            }
            Box(
                modifier = Modifier
                    .size(40.px)
                    .padding(6.px)
                    .border(width = 1.px, LineStyle.Solid, Colors.lineBorder)
                    .borderRadius(6.px)
                    .backgroundColor(Colors.White)
                    .cursor(Cursor.Pointer)
                    .onClick { showMenu = !showMenu }
            ) {
                /*Image(
                    src = "/dots-vertical1.svg",
                    description = "Options",
                    modifier = Modifier.size(25.px)
                )*/
                FaEllipsisVertical(
                    modifier = Modifier.fontSize(20.px)
                )
            }

            if (showMenu) {
                Box(
                    modifier = Modifier
                        .position(Position.Fixed)
                        .top(0.px)
                        .left(0.px)
                        .width(100.vw)
                        .height(100.vh)
                        .zIndex(99)
                        .onClick { showMenu = false }
                )
                CardDropdownMenu(
                    onEdit = { showMenu = false; onEdit() },
                    onDelete = { showMenu = false; onDelete() },
                    onDownload = { showMenu = false; onDownload() },
                    onDismiss = { showMenu = false }
                )
            }
        }
        SpanText(
            text = title,
            modifier = CreateCardSpantextStylecss.toModifier()
//                .width(cardW)
                .fontFamily(INTER)
                .fontSize(13.px)
                .fontWeight(FontWeight.Medium)
                .color(Colors.Black)
                .styleModifier {
                    property("overflow", "hidden")
                    property("text-overflow", "ellipsis")
                    property("white-space", "nowrap")
                }
        )
        SpanText(
            text = "Modifié $modifiedAgo",
            modifier = Modifier
                .fontFamily(INTER)
                .fontSize(11.px)
                .color(Colors.Graytext)
        )
    }
}

@Composable
fun CardDropdownMenu(
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onDownload: () -> Unit,
    onDismiss: () -> Unit
) {
    Column(
        modifier = Modifier
            .position(Position.Absolute)
            .bottom(50.px)
            .right(0.px)
            .width(180.px)
            .backgroundColor(Colors.White)
            .border(1.px, LineStyle.Solid, Colors.lineBorder)
            .borderRadius(10.px)
            .padding(topBottom = 6.px)
            .zIndex(100)
            .boxShadow(offsetX = 0.px, offsetY = 4.px, blurRadius = 12.px, color = Colors.HalfBlack)
    ) {/*
        CardMenuItem(icon = "/edit-icon.svg", label = "Modifier", onClick = onEdit)
        CardMenuItem(icon = "/download.svg", label = "Télécharger", onClick = onDownload)
        CardMenuItem(icon = "/delete-bin.svg", label = "Supprimer", onClick = onDelete)*/
        CardMenuItem(icon = { modifier -> FaPen(modifier = modifier) }, label = "Modifier", onClick = onEdit)
        CardMenuItem(icon = { modifier -> FaDownload(modifier = modifier) }, label = "Télécharger", onClick = onDownload)
        CardMenuItem(icon = { modifier -> FaTrash(modifier = modifier) }, label = "Supprimer", onClick = onDelete)

    }
}

@Composable
private fun CardMenuItem(
    icon: @Composable (Modifier) -> Unit,
    label: String,
    onClick: () -> Unit
) {
    var hovered by remember { mutableStateOf(false) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(40.px)
            .padding(leftRight = 16.px)
            .backgroundColor(if (hovered) Colors.PriceGray else Colors.White)
            .cursor(Cursor.Pointer)
            .onMouseEnter { hovered = true }
            .onMouseLeave { hovered = false }
            .onClick { onClick() }
            .gap(12.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        /*Image(
            src = icon,
            description = label,
            modifier = Modifier.size(18.px)
        )*/
        icon(
            Modifier
                .fontSize(16.px) // ~équivalent visuel à size(18.px) pour une icône FA
                .color(if (label == "Supprimer") Colors.Warning else Colors.White)
        )
        SpanText(
            text = label,
            modifier = Modifier
                .fontFamily(INTER)
                .fontSize(14.px)
                .color(if (label == "Supprimer") Colors.Warning else Colors.Black)
        )
    }
}
